export default "__VITE_ASSET__dbc28813__"